<template lang="pug">
    .left-panel-layout(v-click-outside='clickOutside')
        .left-panel-layout__close
            div(@click="close")
                svg-icon(iconId="close")

        creator-control.left-panel-layout__creator(:creator="authUser" :includeInfo="false" @goToProfile="close")
        .left-panel-layout__creator-name {{ authUser.name }}
        .left-panel-layout__creator-username @{{ authUser.username }}
        .left-panel-layout__creator-stats
            div {{ authUser.followers_count }} followers
            div {{ authUser.following_count }} followings

        .left-panel-layout__content
            div
                .left-panel-layout__menu
                    div.left-panel-layout__menu-item(v-for="item in menu" @click="itemClick(item)")
                        div(v-if="item.click")
                            div {{ item.name }}
                        router-link(v-else :to="item.route" :target="item.route.target")
                            div {{ item.name }}
</template>

<script>
import { mapGetters } from 'vuex'
import eventBus from '../lib/event-bus'
import events from '../lib/events'

export default {
    name: 'left-panel-layout',

    props: {
        level: {
            type: Number,
            required: true,
        },
        element: {
            type: HTMLElement,
            required: true,
        },
        closeCallback: {
            type: Function,
            required: true,
        },
        menu: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            elementClickCheckedOnce: false,
        }
    },

    computed: {
        ...mapGetters(['authUser']),
    },

    methods: {
        itemClick(item) {
            this.close()
            if (item.click) {
                item.click()
            }
        },

        close() {
            this.closeCallback()
            eventBus.$emit(events.CLOSE_MODAL, this.level)
        },
        clickOutside(e) {
            if (this.elementClickCheckedOnce || !e.composedPath().includes(this.element)) {
                this.close()
            }
            this.elementClickCheckedOnce = true
        },
    },
}
</script>
